import { render, staticRenderFns } from "./AddService.vue?vue&type=template&id=12ba4b10&scoped=true"
import script from "./AddService.vue?vue&type=script&lang=js"
export * from "./AddService.vue?vue&type=script&lang=js"
import style0 from "./AddService.vue?vue&type=style&index=0&id=12ba4b10&lang=css"
import style1 from "./AddService.vue?vue&type=style&index=1&id=12ba4b10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba4b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ba4b10')) {
      api.createRecord('12ba4b10', component.options)
    } else {
      api.reload('12ba4b10', component.options)
    }
    module.hot.accept("./AddService.vue?vue&type=template&id=12ba4b10&scoped=true", function () {
      api.rerender('12ba4b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AddService.vue"
export default component.exports